import React from 'react';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown';

import { rendererTwo } from '../count-down';

function ProductFive( props ) {
    const { product, onAddToCart, showQuickView } = props;

    const addToCartHandler = () => {
        if ( 0 !== product.stock )
            onAddToCart( product, 1 );
    }

    const quickViewHandler = () => {
        showQuickView( product.id );
    }

    return (
        product ?
            <div className={ `product product-4 text-center ${0 === product.stock ? 'product-disabled' : ''}` }>
                <figure className="product-media">
                    
                </figure>

                <div className="product-body product-action-inner">
                    <h3 className="product-title">
                        { product.nameFr }
                    </h3>

                    {/*
                        0 === product.stock ?
                            <div className="product-price">
                                <span className="new-price">${ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }</span>
                            </div> :

                            0 < product.discount ?
                                <div className="product-price">
                                    <span className="new-price">${ product.salePrice.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }</span>
                                    <span className="old-price">${ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }</span>
                                </div> :

                                <div className="product-price">${ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }</div>
                    */}

                    {/* 0 === product.stock ? <div className="product-label-text">Out Of Stock</div> : '' */}

                    {/*
                        product.variants ?
                            product.variants[ 0 ].model ?
                                <div className="product-nav product-nav-thumbs">
                                    { product.variants.map( ( vari, i ) =>
                                        <Link to="#" key={ i } className={ 0 === i ? 'active' : '' }>
                                            <img src={ process.env.REACT_APP_PUBLIC_URL + '/' + vari.model } alt="product desc" />
                                        </Link>
                                    ) }
                                </div>
                                :
                                <div className="product-nav product-nav-dots">
                                    { product.variants.map( ( vari, i ) =>
                                        <Link to="#" key={ i } className={ 0 === i ? 'active' : '' } style={ { background: vari.color } }>
                                        </Link>
                                    ) }
                                </div>
                            : ''
                    */}
                </div>
            </div>
            : ''
    );
}

export default React.memo( ProductFive );